<div
  class="small-list-item-hero bg-white dark:bg-gray-950 text-black dark:text-white text-xs {{ isClickable ? 'hover:bg-gray dark:hover:bg-gray-900' : '' }} select-none"
  (click)="isClickable ? click() : ''">

  <div class="insert-container" #ref>
    <ng-content></ng-content>
  </div>

  <!-- if no ng-content -->
  @if (!ref.hasChildNodes()) {
    <div class="flex flex-row items-center max-w-full w-full h-full rounded bg-gray-850">
      @if (bubbleColour) {
        <app-bubble class="h-full px-1" style="max-height: 20px;" [color]="bubbleColour"></app-bubble>
      }
      @if (text) {
        <span class="text" [innerHTML]="text"></span>
      }
      <div class="custom-end">
        @if (date) {
          <span class="date text-gray-700 dark:text-white">{{ date | localizedDate : dateFormat }}</span>
        }
        @if (isClickable && !icon) {
          <app-icon class="icon" [icon]="icons.pencil" height="h-2" width="w-2"></app-icon>
        }
        @if (icon) {
          <app-icon fontSize="14px" size="3" class="icon ml-1" [icon]="icon"></app-icon>
        }
      </div>
    </div>
  }
</div>
